import React from "react";
import { Col, Input, Label, Row } from "reactstrap";

export type MaterialStatusFilter = "" | "active" | "inactive";

export type MaterialListFiltersProps = {
  statusFilter: MaterialStatusFilter;
  onStatusChange: (value: MaterialStatusFilter) => void;
};

export default function MaterialListFilters({
  statusFilter,
  onStatusChange,
}: MaterialListFiltersProps) {
  return (
    <Row className="g-2 g-md-3 align-items-end flex-grow-1 w-100 mb-0">
      <Col xs={12} sm={6} md={4} lg={3}>
        <Label className="form-label text-muted small mb-1">Status</Label>
        <Input
          type="select"
          className="form-select"
          value={statusFilter}
          onChange={(e) =>
            onStatusChange(e.target.value as MaterialStatusFilter)
          }
        >
          <option value="">All</option>
          <option value="active">Active</option>
          <option value="inactive">Inactive</option>
        </Input>
      </Col>
    </Row>
  );
}
